module.exports = __webpack_public_path__ + "img/logo@2x.c9ee05ba.png";